"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModuleRegistryMethodName = exports.MODULE_REGISTRY_NAMESPACE = exports.BUSINESS_MANAGER_MODULE_ID = void 0;
exports.BUSINESS_MANAGER_MODULE_ID = 'BROWSER_NOTIFICATIONS';
exports.MODULE_REGISTRY_NAMESPACE = 'ping';
exports.getModuleRegistryMethodName = function (methodName) {
    return exports.MODULE_REGISTRY_NAMESPACE + "." + methodName;
};
//# sourceMappingURL=types.js.map